module.exports = __webpack_public_path__ + "img/Bojan.c7e0abf8.png";